import { ABtn } from '@maisaedu/ui-components-a-btn';
import commonMixin from '@/mixins/templates/common';
import { TemplateName } from '@/helpers/templateType';

export default {
  mixins     : [commonMixin],
  components : {
    ABtn
  },
  props: {
    isOpen: {
      type    : Boolean,
      default : false
    },
    countModules: {
      type    : Number,
      default : 0
    },
    maxModule: {
      type    : Number,
      default : 0
    }
  },
  data() {
    return {
      TemplateName,
      currentMaxModule: this.maxModule
    };
  },
  computed: {
    templateStreaming() {
      return this.templateName === this.TemplateName.STREAMING;
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal');
    },
    isNumber(evt) {
      const myEvent = (evt) || window.event;
      const charCode = (myEvent.which) ? myEvent.which : myEvent.keyCode;

      if (charCode === 44 || charCode === 46 || charCode === 101) {
        myEvent.preventDefault();
      } else {
        return true;
      }
    },
    changeMaxModuleValue() {
      if (this.countModules > this.currentMaxModule) {
        this.$dialog.show({
          type                 : 'info',
          title                : this.$t('content.layout.timeline.course.approvalFlow.changeMaxModule.titleModalMessage'),
          message              : this.$t('content.layout.timeline.course.approvalFlow.changeMaxModule.infoModalMessage'),
          showCancelButton     : false,
          confirmButtonVariant : 'text'
        });

        return;
      }

      this.$emit('changeMaxModuleValue', this.currentMaxModule);
      this.closeModal();
    }
  }
};
